module.exports = __webpack_public_path__ + "img/index_pic31.f84c6c84.png";